module.exports = __webpack_public_path__ + "src/img/filter.3846d134.svg";